import React from "react";

export function useImageAspect(url) {
    const [ratio, setRatio] = React.useState(null);
    React.useEffect(() => {
        if (!url) return setRatio(null);
        const img = new Image();
        img.onload = () => setRatio(img.naturalWidth / img.naturalHeight || null);
        img.src = url;
    }, [url]);
    return ratio;
}

export function pickAspectFor(network, r) {
    if (!r || !isFinite(r)) return "1/1";
    if (r <= 0.95) return "4/5";
    if (r >= 1.5) return "16/9";
    return "1/1";
}

export default function RatioBox({
                                     src,
                                     ratio = "1/1",
                                     radius = 8,
                                     fit = "contain",
                                     style,
                                     children,
                                 }) {
    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                aspectRatio: ratio,
                borderRadius: radius,
                overflow: "hidden",
                background: "#f0f0f0",
                ...style,
            }}
        >
            {src && (
                <img
                    src={src}
                    alt=""
                    draggable={false}
                    style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: fit,
                        backfaceVisibility: "hidden",
                    }}
                />
            )}
            {children}
        </div>
    );
}
